export default function CConstKeyword() {
  return <h2>C Const Keyword</h2>;
}
